(() => {
  window.swinger.eventHub.register('click', window.swinger.focusableElements.map((selector) => `.swinger-accordion__item-title ${selector}`).join(','), (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (elem.matches('[tabindex]:not([role])')) {
      e.preventDefault();
    }

    e.stopImmediatePropagation();
  });
})();
